import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Login } from './login.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  isAuthenticated = false;
  info?: any;
  GUIDValue!: string;
  private loginDetails = new BehaviorSubject<Login>({});
  public firstAuthId!: string;
  public mfaChoices!: Array<null>;
  public email!: string;
  public password!: string;

  constructor(
    ) { }


}
